// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3f0jo","imageUploader":"EGiftCard_imageUploader__1uwdZ"};